module.exports = __webpack_public_path__ + "img/갓핸드.b1caff15.png";